import { type ApolloQueryResult } from '@apollo/client';
import { createContext } from 'react';
import {
    type CompanyWithPermissionsContextDataFragment,
    type CurrentUserCompaniesDataFragment,
} from '../../../api/fragments';
import { type CompanyContextDataFragment } from '../../../api/fragments/CompanyContextData';
import { type GetAuthenticatedUserCompaniesQuery } from '../../../api/queries/getAuthenticatedUserCompanies';

export type RefetchUserCompanies = (
    variables?: Partial<{
        companyId?: string;
    }>
) => Promise<ApolloQueryResult<GetAuthenticatedUserCompaniesQuery>>;

export type CompanyContextData = {
    replace: (companyId: string | null) => void;
    userDataFromCompanies: CurrentUserCompaniesDataFragment;
    companies: CompanyWithPermissionsContextDataFragment[];
    availableCompanies: CompanyContextDataFragment[];
    allCompaniesSelected: boolean;
    refetch: RefetchUserCompanies;
    timeZonesByModuleId: { [key: string]: string };
};

export const CompanyContext = createContext<CompanyContextData | null>(null);
